/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OIDCChallengeOptions
 */
export interface OIDCChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof OIDCChallengeOptions
     */
    auth_code_url: string;
}

/**
 * Check if a given object implements the OIDCChallengeOptions interface.
 */
export function instanceOfOIDCChallengeOptions(value: object): value is OIDCChallengeOptions {
    if (!('auth_code_url' in value) || value['auth_code_url'] === undefined) return false;
    return true;
}

export function OIDCChallengeOptionsFromJSON(json: any): OIDCChallengeOptions {
    return OIDCChallengeOptionsFromJSONTyped(json, false);
}

export function OIDCChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OIDCChallengeOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_code_url': json['auth_code_url'],
    };
}

export function OIDCChallengeOptionsToJSON(json: any): OIDCChallengeOptions {
    return OIDCChallengeOptionsToJSONTyped(json, false);
}

export function OIDCChallengeOptionsToJSONTyped(value?: OIDCChallengeOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_code_url': value['auth_code_url'],
    };
}

